// Bu dosya hem size-chart section'ından hem size-chart-modal snippet'inden
// yüklenir; aynı sayfada iki kez çalışabilir. IIFE, `strings`i modül kapsamında
// tutar (global `const` çift tanımlanırsa SyntaxError atardı).
(function () {
  // Çeviriler theme.liquid'deki window.sizeChartStrings'ten gelir (Dawn'ın
  // window.variantStrings deseni). Tanımlı değilse Türkçe metne düşer.
  const strings = Object.assign(
    {
      finderHint: 'Ayak uzunluğunu cm olarak girin, size en uygun bedeni gösterelim.',
      finderResult: 'Sizin için:',
    },
    window.sizeChartStrings || {}
  );

  if (!customElements.get('size-chart')) {
    customElements.define('size-chart', class extends HTMLElement {
      connectedCallback() {
        // Tab switching
        this.querySelectorAll('.size-chart__tab').forEach((tab) => {
          tab.addEventListener('click', () => {
            const targetId = tab.dataset.target;
            this.querySelectorAll('.size-chart__tab').forEach((t) => {
              t.classList.remove('is-active');
              t.setAttribute('aria-selected', 'false');
            });
            this.querySelectorAll('.size-chart__panel').forEach((p) => p.classList.remove('is-active'));
            tab.classList.add('is-active');
            tab.setAttribute('aria-selected', 'true');
            const panel = this.querySelector('#' + targetId);
            if (panel) panel.classList.add('is-active');
          });
        });

        // Size finder
        this.querySelectorAll('[data-finder]').forEach((input) => {
          input.addEventListener('input', (e) => {
            const cm = parseFloat(e.target.value);
            const panel = e.target.closest('.size-chart__panel');
            if (!panel) return;
            const rows = panel.querySelectorAll('tbody tr');
            const output = panel.querySelector('[data-finder-output]');
            rows.forEach((row) => row.classList.remove('is-recommended'));

            if (!cm || isNaN(cm) || cm < 18 || cm > 35) {
              if (output) output.textContent = strings.finderHint;
              return;
            }

            let bestRow = null;
            let bestDiff = Infinity;
            rows.forEach((row) => {
              const rowCm = parseFloat(row.dataset.cm);
              if (isNaN(rowCm)) return;
              const diff = Math.abs(rowCm - cm);
              if (diff < bestDiff) {
                bestDiff = diff;
                bestRow = row;
              }
            });

            if (bestRow) {
              bestRow.classList.add('is-recommended');
              bestRow.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
              const cells = bestRow.querySelectorAll('td');
              const heads = Array.from(bestRow.closest('table').querySelectorAll('thead th')).map((th) => th.textContent.trim());
              const parts = Array.from(cells)
                .map((td, i) => (heads[i] && heads[i] !== 'CM' ? heads[i] + ' ' + td.textContent : null))
                .filter(Boolean);
              if (output && parts.length) {
                output.innerHTML = '<span>' + strings.finderResult + ' <strong>' + parts.join(' • ') + '</strong></span>';
              }
            }
          });
        });
      }
    });
  }
})();
